import CityAPI from 'api/city';
import DestinationAPI from 'api/destination';
import {parseSlug} from 'utils/page-utils';

const getInitialState = async ({state, params}) => {
    const citySlug = params.city;
    const {data: city} = await CityAPI.get(citySlug);
    const slug = parseSlug(params.slug);
    const results = await DestinationAPI.getAllInCityByCategorySlug({
        city: citySlug,
        category: slug,
    }).then(res => res.data.data.results);

    return {
        ...state,
        city,
        category: {
            data: {
                slug,
                results,
            },
        },
    };
};

export default getInitialState;
